<template>
  <div class="layout-toggle">
    <button
      class="toggle-button flex items-center justify-center"
      title="Toggle layout mode"
      @click="toggleLayout"
    >
      <AppIcon
        class="text-surface-700"
        size="xl"
        :icon="
          layoutStore.currentLayout === 'default'
            ? 'fa-regular fa-square-left'
            : 'fa-regular fa-table-layout'
        "
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import {
  useLayoutPreferencesStore,
  type LayoutOption,
} from '~/stores/layoutPreferences'

const layoutStore = useLayoutPreferencesStore()

function toggleLayout() {
  // Toggle between 'default' and 'float' layouts
  const newLayout: LayoutOption =
    layoutStore.currentLayout === 'default' ? 'float' : 'default'
  layoutStore.setDefaultLayout(newLayout)
}
</script>

<style scoped>
.layout-toggle {
  position: relative;
}

.toggle-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.toggle-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
